import { styled } from '@engyalo/design-system';

export const FontSizeWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-top: 8px;
  margin-bottom: 16px;
`;
